import React from "react";
import "./School.css";
import {
  CheckCircleFilled,
  ArrowRightOutlined,
  BookOutlined,
  SafetyCertificateOutlined,
  CloudOutlined,
  RocketOutlined,
  CheckOutlined,
  ThunderboltFilled,
  TeamOutlined,
  BankOutlined,
  ReadOutlined,
} from "@ant-design/icons";
import schoolImage from "../../Asset/school-management.png";

const featuresLeft = [
  "Student Admission",
  "Fees Module",
  "Student ID-Card",
  "Student Promotion",
  "Student Certificate (T.C, C.C, Migration)",
  "Examination",
  "Time-table",
  "Attendance",
  "Academic Calendar",
  "Hostel Management",
  "Inventory Management",
  "Expense Management",
];

const featuresRight = [
  "Transport Management",
  "Library Management",
  "Pay-roll System",
  "Enquiry & Visitors",
  "Home-work Management",
  "Birthday Reminders",
  "Achievement Tracking",
  "Canteen Billing",
  "SMS & WhatsApp Integration",
  "User Privileges & Roles",
  "Comprehensive Reports",
];

const highlights = [
  {
    icon: <TeamOutlined />,
    title: "Student Management",
    desc: "Complete student lifecycle tracking",
  },
  {
    icon: <BankOutlined />,
    title: "Fees & Accounts",
    desc: "Automated billing & payments",
  },
  {
    icon: <ReadOutlined />,
    title: "Academic Suite",
    desc: "Exams, results & reports",
  },
];

function School() {
  const handleViewMore = () => {
    window.open("/school-details", "_blank");
  };

  return (
    <div className="sms-page-light">
      {/* Decorative Background */}
      <div className="sms-bg-grid"></div>
      <div className="sms-glow-1"></div>
      <div className="sms-glow-2"></div>

      <div className="sms-container">
        
        {/* ═══════ PROFESSIONAL HEADER ═══════ */}
        <div className="sms-header-new">
          <div className="sms-header-top">
            <span className="sms-badge">
              <span className="sms-badge-dot"></span>
              EDUCATION PRODUCT
            </span>
            <span className="sms-version-tag">
              <ThunderboltFilled /> Version 4.0
            </span>
          </div>

          <div className="sms-header-main">
            <div className="sms-header-icon-box">
              <BookOutlined />
            </div>
            <div className="sms-header-text">
              <h1 className="sms-title-new">
                School Management <span className="sms-gradient-text">System</span>
              </h1>
              <p className="sms-subtitle-new">
                A comprehensive cloud-based platform designed to streamline academic operations, 
                automate administrative tasks, and empower educational institutions with 
                real-time insights and end-to-end management capabilities.
              </p>
            </div>
          </div>

          {/* Meta Info Pills */}
          <div className="sms-meta-pills">
            <span className="sms-meta-pill">
              <CheckOutlined /> Live Demo Available
            </span>
            <span className="sms-meta-pill">
              <SafetyCertificateOutlined /> Multi-School Ready
            </span>
            <span className="sms-meta-pill">
              <CloudOutlined /> Cloud-Based Software
            </span>
            <span className="sms-meta-pill">
              <RocketOutlined /> 24/7 Support Included
            </span>
          </div>
        </div>

        {/* MAIN CONTENT GRID */}
        <div className="sms-main-content">
          
          {/* LEFT — IMAGE & HIGHLIGHTS */}
          <div className="sms-left-col">
            <div className="sms-image-wrapper">
              <div className="sms-image-glow"></div>
              <img
                src={schoolImage}
                alt="School Management System"
                className="sms-image"
              />
              <div className="sms-image-badge">
                <BookOutlined /> SMS Dashboard
              </div>
            </div>

            {/* Highlights Row */}
            <div className="sms-highlights">
              {highlights.map((item, index) => (
                <div className="sms-highlight-card" key={index}>
                  <div className="sms-highlight-icon">{item.icon}</div>
                  <div className="sms-highlight-text">
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — INFORMATION */}
          <div className="sms-right-col">
            <div className="sms-info-block">
              <p className="sms-para">
                Our <strong>School Management Software (SMS)</strong> is a powerful, 
                cloud-based application designed to manage all critical processes of 
                schools and educational institutions. From admissions to certifications, 
                every operation is handled seamlessly under one unified platform.
              </p>

              <p className="sms-para">
                The system efficiently handles <strong>Admissions, Fees Collection, 
                Student Promotions, Attendance, ID Cards, Certifications, Examinations, 
                Reports</strong> and much more — empowering administrators, teachers, 
                and parents with real-time information and complete transparency.
              </p>
            </div>

            {/* FEATURES SECTION */}
            <div className="sms-features-section">
              <h2 className="sms-features-title">
                <span className="title-accent">Key Features</span> & Benefits
              </h2>
              <p className="sms-features-desc">
                Explore the complete suite of powerful features designed to modernize 
                your educational institution's operations.
              </p>

              <div className="sms-features-grid">
                <ul className="sms-features-list">
                  {featuresLeft.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="sms-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <ul className="sms-features-list">
                  {featuresRight.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="sms-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* CTA BUTTON */}
            {/* <div className="sms-cta-wrap">
              <button className="sms-view-btn" onClick={handleViewMore}>
                <span>Explore Full Details</span>
                <ArrowRightOutlined />
              </button>
              <p className="sms-cta-note">
                💡 Get a live demo and pricing consultation
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default School;